

























import Vue from 'vue';

import { reportErrorToParent } from '@/utils/iframeMessageRequester';

export default Vue.extend({
  name: 'ErrorBoundary',
  props: {
    label: { type: String, default: 'This section' },
    source: { type: String, default: 'error-boundary' },
  },
  data() {
    return {
      error: null as Error | null,
      renderKey: 0,
      showDetails: process.env.NODE_ENV !== 'production',
    };
  },
  errorCaptured(err: Error, _vm, info: string) {
    const handledMarker = '__bitwaveErrorHandled';
    if ((err as any)?.[handledMarker]) {
      return false;
    }

    // Vue 2 info strings: 'render', 'mounted hook', 'beforeCreate hook', 'v-on handler', etc.
    // Only treat render/lifecycle errors as boundary failures; everything else just gets reported.
    const renderLike = ['render', 'mount', 'beforeCreate', 'created', 'update', 'computed'];
    const isRenderError = renderLike.some((s) => info.toLowerCase().includes(s.toLowerCase()));

    if (isRenderError) {
      this.error = err;
    }

    reportErrorToParent(err, this.source, info);
    console.error(`[ErrorBoundary:${this.source}]`, err, info);

    try {
      (err as any)[handledMarker] = true;
    } catch {
      // frozen error — best effort
    }
    return false;
  },
  methods: {
    retry() {
      this.error = null;
      this.renderKey += 1;
    },
    goHome() {
      this.error = null;
      this.renderKey += 1;
      this.$router.push('/').catch((err) => {
        console.warn('[ErrorBoundary] navigation to home failed', err);
      });
    },
  },
});
